import { Flex } from 'common/src/designSystem/components/flex';
import { Spacer } from 'common/src/designSystem/components/spacer';
import { Predicate, PredicateOperator } from 'common/src/generated/types';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import { FilterPredicate } from 'common/src/vo/segment';
import { DateTime } from 'luxon';
import * as React from 'react';
import { Button } from '../../designSystem/components/button';
import { DateInput } from '../../designSystem/components/date/dateInput';
import { Label } from '../../designSystem/components/input/label';
import { RadioText } from '../../designSystem/components/radio';
import { TextInput } from '../../designSystem/components/textInput';

interface IAddNumberOfAssignmentsPerDayFilterProps {
    filterPredicate: FilterPredicate;

    onAdd(predicate: Predicate): void;
}

export const AddNumberOfAssignmentsPerDayFilter = (
    props: IAddNumberOfAssignmentsPerDayFilterProps
) => {
    const translate = useTranslate();
    const [operator, setOperator] = React.useState<PredicateOperator>(
        props.filterPredicate.predicate?.operator ?? PredicateOperator.Is
    );
    const [value, setValue] = React.useState<DateTime | string>(
        props.filterPredicate.predicate?.value ?? ''
    );
    const [value2, setValue2] = React.useState(props.filterPredicate.predicate?.value2 ?? '');
    const valid =
        DateTime.isDateTime(value) &&
        value?.isValid &&
        ['is', 'isNot', 'greaterThan', 'greaterThanEqual', 'lessThan', 'lessThanEqual'].includes(
            operator
        )
            ? typeof value2 === 'number'
            : false;

    return (
        <>
            <DateInput
                label={translate('jour_d_affectat_27334')}
                max={props.filterPredicate.filter.endAt}
                min={props.filterPredicate.filter.startAt}
                value={value}
                onChange={setValue}
            />

            <Spacer height="6" />

            <Label>{props.filterPredicate.filter.name}</Label>

            <Spacer height="1" />

            <RadioText
                state={operator === 'is' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.Is);
                }}
            >
                {translate('est_25967')}
            </RadioText>

            {operator === 'is' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="3" />

            <RadioText
                state={operator === 'isNot' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.IsNot);
                }}
            >
                {translate('n_est_pas_97826')}
            </RadioText>

            {operator === 'isNot' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="3" />

            <RadioText
                state={operator === 'greaterThan' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.GreaterThan);
                }}
            >
                {translate('plus_grand_que_28412')}
            </RadioText>

            {operator === 'greaterThan' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="3" />

            <RadioText
                state={operator === 'greaterThanEqual' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.GreaterThanEqual);
                }}
            >
                {translate('_gal_ou_plus_gr_76897')}
            </RadioText>

            {operator === 'greaterThanEqual' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="3" />

            <RadioText
                state={operator === 'lessThan' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.LessThan);
                }}
            >
                {translate('plus_petit_que_35846')}
            </RadioText>

            {operator === 'lessThan' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="3" />

            <RadioText
                state={operator === 'lessThanEqual' ? 'checked' : 'unchecked'}
                onClick={() => {
                    setOperator(PredicateOperator.LessThanEqual);
                }}
            >
                {translate('_gal_ou_plus_pe_38400')}
            </RadioText>

            {operator === 'lessThanEqual' && (
                <>
                    <Spacer height="1" />

                    <Flex>
                        <Spacer width="6" />
                        <TextInput
                            min={0}
                            shouldParseAsInt={true}
                            value={value2}
                            onChange={setValue2}
                        />
                    </Flex>

                    <Spacer height="1" />
                </>
            )}

            <Spacer height="7" />

            <Flex>
                <Button
                    disabled={!valid}
                    onClick={() => {
                        props.onAdd({
                            operator,
                            value,
                            value2,
                            slug: props.filterPredicate.filter.slug
                        });
                    }}
                >
                    {translate('ajouter_le_filt_54222')}
                </Button>
            </Flex>
        </>
    );
};
